export * from './get-my-result'
export * from './get-test-by-id'
export * from './get-test-info'
export * from './get-test-quiz'
export * from './get-topic-test'
